<div class="upload-container">
  <div class="upload-info">
    <h1>Informações do Negócio</h1>
    <p>
      Esse formulário indica os atributos relacionados ao arquivo.
      <span>Campos com (*) são obrigatórios.</span>
    </p>
  </div>
  <div class="inputs-container">
    <form class="form-solicitacao">
      <mat-form-field
        class="input-area-identificacao"
        [class.span-2]="!isCarFieldHidden"
      >
        <mat-label>Identificação da Área</mat-label>
        <mat-select required [formControl]="form.controls.featurePrimaryKey">
          @for (field of metadata?.fields; track $index) {
            <mat-option value="{{ field }}">{{
              field.toUpperCase()
            }}</mat-option>
          }
        </mat-select>

        @if (form.controls.featurePrimaryKey.hasError("duplicate")) {
          <mat-error>
            O campo {{ form.controls.featurePrimaryKey.value }} não possui um
            valor único para cada área ou possui valores nulos
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field class="input-area-identificacao">
        <mat-label>Contrato</mat-label>
        <mat-select [formControl]="form.controls.contract">
          <mat-option [value]="null">NENHUM</mat-option>

          @for (field of metadata?.fields; track $index) {
            <mat-option [value]="field">
              {{ field.toUpperCase() }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      @if (!isCarFieldHidden) {
        <mat-form-field class="input-area-identificacao">
          <mat-label>CAR</mat-label>
          <mat-select
            [required]="isCarRequired() == true"
            [formControl]="form.controls.car"
          >
            <mat-option [value]="null">NENHUM</mat-option>
            @for (field of metadata?.fields; track $index) {
              <mat-option [value]="field">
                {{ field.toUpperCase() }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }

      <mat-form-field class="input-area-identificacao">
        <mat-label>Apólice</mat-label>
        <mat-select [formControl]="form.controls.insurancePolicy">
          <mat-option [value]="null">NENHUM</mat-option>
          @for (field of metadata?.fields; track $index) {
            <mat-option [value]="field">
              {{ field.toUpperCase() }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field class="input-area-identificacao">
        <mat-label>Nome da Fazenda</mat-label>
        <mat-select [formControl]="form.controls.farmName">
          <mat-option [value]="null">NENHUM</mat-option>
          @for (field of metadata?.fields; track $index) {
            <mat-option [value]="field">
              {{ field.toUpperCase() }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field class="input-area-identificacao">
        <mat-label>Produtor</mat-label>
        <mat-select [formControl]="form.controls.producer">
          <mat-option [value]="null">NENHUM</mat-option>
          @for (field of metadata?.fields; track $index) {
            <mat-option [value]="field">
              {{ field.toUpperCase() }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field class="input-area-identificacao">
        <mat-label>CPF/CNPJ</mat-label>
        <mat-select [formControl]="form.controls.identityDocument">
          <mat-option [value]="null">NENHUM</mat-option>
          @for (field of metadata?.fields; track $index) {
            <mat-option [value]="field">
              {{ field.toUpperCase() }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </form>
  </div>
</div>
